import {NetworkNamesEnum} from "@shared/enums/networks.enum";
import bs58 from "bs58";

export const splitKeys = (walletsList: string, network: NetworkNamesEnum, full = false): string[] => {
    return (network === NetworkNamesEnum.solana || network === NetworkNamesEnum.solana_dev) ? parseSolanaKeys(walletsList, full) :
        walletsList?.split(/[\r\n;,]/)
            ?.map((address: string) => address.replace(new RegExp('\n', 'g'), '').trim())
            ?.filter((address: string) => address);
}

export function parseSolanaKeys(keysList: string, full: boolean) {
    if(keysList?.trim()[0] === '[') {
        return keysList?.trim()
            ?.split(/][\r\n;,.]/)
            ?.filter((n) => n)
            ?.map(v => v?.replaceAll(/[\[\s;\]]/g, ''))
            ?.map(v => full ? '[' + v.trim() + ']' : v)
    } else {
        return keysList?.split(/[\r\n;,]/)
            ?.map((address: string) => address.replace(new RegExp('\n', 'g'), '').trim())
            ?.filter((address: string) => address)
            ?.map(base58address => full ? '[' + bs58.decode(base58address).toString() + ']' : bs58.decode(base58address).toString());
    }
}

export const splitWallets = (walletsList: string): string[] => {
    return walletsList?.split(/[\r\n;,]/)
            ?.map((address: string) => address.replace(new RegExp('\n', 'g'), '').trim())
            ?.filter((address: string) => address);
}
